type TripIdentityData =
  | {
      result?: {
        division?: { division?: string | null } | null;
        trip?: { trip_name?: string | null } | null;
      } | null;
    }
  | null
  | undefined;

const hasTripIdentity = (tripData: TripIdentityData): boolean =>
  Boolean(tripData?.result?.division?.division?.trim()) &&
  Boolean(tripData?.result?.trip?.trip_name?.trim());

const isLiteTrip = (tripData: TripIdentityData): boolean => {
  if (!hasTripIdentity(tripData)) return false;

  const division = tripData?.result?.division?.division;
  const tripName = tripData?.result?.trip?.trip_name;

  return (
    division?.toLowerCase() === 'working holiday' &&
    /\blite\b/i.test(tripName || '')
  );
};

export { hasTripIdentity, isLiteTrip };
